@if (token() && !error()) {
  <div @panelTransition>
    <ng-container [ngTemplateOutlet]="autoLoginTemplate" 
                  [ngTemplateOutletContext]="{ token: token() }">
    </ng-container>
  </div>
} @else {
  <div @panelTransition>
    <ng-container [ngTemplateOutlet]="loginTemplate"></ng-container>
  </div>
}

<ng-template #autoLoginTemplate let-token="token">
  <div class="bg-light dark:bg-transparent min-vh-100 d-flex flex-column align-items-center justify-content-center p-4">
    @if (platform.is('desktop') || platform.is('hybrid')) {
      <ng-container>
        <spinner [text]="'login.signingIn'"></spinner>
      </ng-container>
    } @else {
      <app-install (onLink)="onTapAppInstallLink()"></app-install>
      <a  class="continueInBrowser"
          (click)="loginWithJwt(token)" 
          translate="app.install.continueInBrowser">
      </a>
    }
  </div>
</ng-template>
  
<ng-template #loginTemplate>
  <div class="bg-light dark:bg-transparent min-vh-100 d-flex flex-row align-items-center position-relative" style="padding-bottom: 48px;">
    <lib-auth-language-switcher></lib-auth-language-switcher>
    <c-container breakpoint="md">
      <c-row class="justify-content-center">
        <c-col lg="6" xl="4">
          <c-card-group>
            <c-card class="overflow-hidden">
              <c-card-body class="p-4 pb-5">
                <form cForm (ngSubmit)="login()">
                  <app-logo></app-logo>
                  <!-- <p class="text-body-secondary" translate="login.signIn"></p> -->
                  <c-input-group class="mb-3">
                    <span cInputGroupText>
                      <svg cIcon name="cilUser"></svg>
                    </span>
                    <input class="form-control"
                          [(ngModel)]="email"
                          name="email"
                          type="text"
                          placeholder="Username or Email"
                          unassistedInput>
                  </c-input-group>
                  <c-input-group class="mb-4">
                    <span cInputGroupText>
                      <svg cIcon name="cilLockLocked"></svg>
                    </span>
                    <input class="form-control" 
                        [(ngModel)]="password"
                        name="password"
                        type="password"
                        placeholder="Password"
                        unassistedInput>
                  </c-input-group>
                  <c-row *ngIf="error() as error" class="alert alert-danger" @alertTransition>
                    <c-col>
                      <span>{{ ('login.error.'+error) | translate }}</span>
                    </c-col>
                  </c-row>
                  <c-row class="login-button-row">
                    <c-col>
                      <button cButton 
                              color="primary" 
                              type="submit" 
                              i18n="@@loginButton" 
                              translate="login.login">
                        </button>
                    </c-col>
                    <!--
                    <c-col class="text-right" xs="6">
                      <button cButton class="px-0" color="link">
                        Forgot password?
                      </button>
                    </c-col>
                    -->
                  </c-row>
                  <c-row *ngIf="config?.passwordRecovery || config?.register">
                    <c-col *ngIf="config?.register" class="text-start">
                      <a routerLink="/forgot-password" 
                         [routerLink]="config?.registerUrl || '/register'" 
                         translate="login.register">
                      </a>
                      <!-- <button cButton 
                              class="px-0" 
                              color="link" 
                              type="button" 
                              [routerLink]="config?.registerUrl || '/register'" 
                              translate="login.register">
                      </button> -->
                    </c-col>
                    <c-col *ngIf="config?.passwordRecovery" class="text-end">
                      <a routerLink="/forgot-password" 
                         routerLink="/forgot-password" 
                         translate="login.forgotPassword">
                      </a>
                      <!-- <button cButton 
                              class="px-0" 
                              color="link" 
                              type="button" 
                              outerLink="/forgot-password" 
                              translate="login.forgotPassword">
                      </button> -->
                    </c-col>
                  </c-row>
                </form>
              </c-card-body>
              <div class="actions">
                @if (config?.actions; as actions) {
                  @for (action of actions; track action.labelKey || action.label) {
                    <div class="action">
                      @if (action.routerLink) {
                        <a [routerLink]="action.routerLink">
                          @if (action.labelKey) {
                            <span [translate]="action.labelKey"></span>
                          } @else {
                            {{ action.label }}
                          }
                        </a>
                      } @else if (action.policy; as policy) {
                        <a (click)="openPolicy(policy)">
                          @if (action.labelKey) {
                            <span [translate]="action.labelKey"></span>
                          } @else {
                            {{ action.label }}
                          }
                        </a>
                      }
                    </div>
                  }
                } @else {
                  <div class="action">
                    <a (click)="openPolicy('privacy_policy')" translate="policy.privacy"></a>
                  </div>
                  <div class="action">
                    <a (click)="openPolicy('terms_of_service')" translate="policy.tos"></a>
                  </div>
                  <div class="action">
                    <a (click)="openPolicy('legal_notice')" translate="policy.legalNotice"></a>
                  </div>
                }
              </div>
            </c-card>
          </c-card-group>
        </c-col>
      </c-row>
    </c-container>
    @if (footer(); as footerText) {
      <div class="footer" (click)="onTapFooter($event)">
        <span [innerHtml]="footerText | safeHtml"></span>
      </div>
    }
  </div>
</ng-template>

<c-offcanvas
  #offcanvas
  placement="end"
  id="OffcanvasStart"
  [visible]="sidePanelVisible()"
  (visibleChange)="sidePanelVisibleChange($event)"
>
  <c-offcanvas-header>
    <!-- <h5 cOffcanvasTitle translate="policy"></h5> -->
    <button
      cButtonClose
      class="text-reset ms-auto"
      cOffcanvasToggle="OffcanvasStart"
      aria-label="Close"
    ></button>
  </c-offcanvas-header>
  <c-offcanvas-body>
    @if (loading()) {
      <spinner [text]="'loading' | translate"></spinner>
    } @else {
      <consent [content]="content()"></consent>
    }
  </c-offcanvas-body>
</c-offcanvas>